import { j as s } from "../jsx-runtime-ClSzPYp4.js";
import { s as a } from "../index.esm-DOxVcNnO.js";
import { styled as e } from "styled-components";
import { compose as d, flexbox as i, layout as m, space as p } from "styled-system";
const l = /* @__PURE__ */ e.div.withConfig({
  shouldForwardProp: (o) => a(o)
}).withConfig({
  componentId: "sc-5da0a44e-0"
})([
  "",
  " ",
  ""
], ({ theme: o }) => o.components.logo.base, d(i, m, p)), x = ({ RenderedLogo: o, logoProps: r, ...t }) => /* @__PURE__ */ s.jsx(l, {
  "data-qa-id": "logo",
  ...t,
  children: /* @__PURE__ */ s.jsx(o, {
    role: "img",
    ...r
  })
});
export {
  l as StyledLogo,
  x as default
};
